import { useQuery } from "@tanstack/react-query";

import { organizationQueryOptionsFactory } from "~/admins/factories";

export const useListOrganizationProviders = (organizationId: string) => {
  return useQuery(
    organizationQueryOptionsFactory.detail(organizationId)._ctx.providers(),
  );
};
